import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";

import FnrCard from "UI/FnrCard/FnrCard";
import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";
import FnrIcon from "UI/FnrIcon/FnrIcon";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

import extendedFieldInputContainers from "../containers";

const { IconContainer } = extendedFieldInputContainers;

const RequiredField = () => {
  const [required, setRequired] = extendedFieldHooks.useIsRequiredField();

  const handleSetRequired = () => setRequired(!required);

  return (
    <FnrCard data-cy="ExtendedFields_Required">
      <FnrHorizontalGap>
        <IconContainer $color="textSecondary">
          <FnrIcon icon="fa-asterisk fas" />
        </IconContainer>
        <FnrVerticalGap gap={8}>
          <FnrTypography>
            Would you like to make this information required?
          </FnrTypography>
          <FnrCheckbox on={required} toggleOn={handleSetRequired}>
            <FnrTypography>Required Field</FnrTypography>
          </FnrCheckbox>
        </FnrVerticalGap>
      </FnrHorizontalGap>
    </FnrCard>
  );
};

export default RequiredField;
